<eventq-dialog-popover
  [open]="open()"
  [title]="title()"
  [cancelLabel]="cancelLabel()"
  [confirmLabel]="confirmLabel()"
  [confirmDisabled]="!selectedSiteId()"
  [bodyScroll]="false"
  [anchor]="anchor()"
  [placement]="resolvedPlacement()"
  [panelWidth]="panelWidth()"
  [panelMaxHeight]="panelMaxHeight()"
  (closed)="closed.emit()"
  (confirmed)="onConfirm()"
>
  <eventq-searchable-list
    appearance="popover"
    selectionMode="single"
    [fillHeight]="true"
    [pageSize]="50"
    [columns]="siteColumns"
    [rows]="siteRows()"
    [selectedIds]="selectedIds()"
    [loading]="loading()"
    [skeletonCount]="skeletonCount()"
    [searchQuery]="searchQuery()"
    [searchPlaceholder]="searchPlaceholder()"
    [listAriaLabel]="title()"
    (searchQueryChange)="searchQueryChange.emit($event)"
    (itemSelect)="onSiteSelect($event)"
  />
</eventq-dialog-popover>
